























































import { defineComponent, onMounted, ref, watch } from '@vue/composition-api';
import sl from '@/serviceLocator';

export default defineComponent({
  name: 'GroupView',
  props: {
    groupId: {
      type: String,
      required: true,
    },
  },
  setup({ groupId }) {
    const server = sl.get('serverProxy');
    const actions = sl.get('globalActions');
    const groupName = ref('');
    const groupDescription = ref('');
    const editingDescription = ref(false);
    const loading = ref(true);
    const tab = ref(null);
    const editDescription = ref('');

    const saveDescriptionEdit = async () => {
      try {
        await server.updateGroupDescription(Number(groupId), {
          description: editDescription.value,
        });
        groupDescription.value = editDescription.value;
      } catch (err) {
        actions.showErrorSnackbar(
          'Error updating group description. Please try again.',
          err as Error
        );
      } finally {
        editingDescription.value = false;
      }
    };

    onMounted(async () => {
      loading.value = true;
      try {
        const groupInfo = await server.getGroupInfo(Number(groupId));
        groupName.value = groupInfo.name;
        groupDescription.value =
          groupInfo.description || 'No group description';
      } catch (err) {
        actions.showErrorSnackbar(
          'Error loading group information. Please try again.',
          err as Error
        );
      } finally {
        loading.value = false;
      }
    });

    watch(
      groupDescription,
      () => (editDescription.value = groupDescription.value)
    );

    return {
      loading,
      groupName,
      groupDescription,
      editingDescription,
      tab,
      saveDescriptionEdit,
      editDescription,
    };
  },
});
